
import React from 'react';
import Helmet from 'react-helmet';

import {
} from './styles';


const MessageCenter = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <Helmet>
      </Helmet>
      <div>

      </div>
    </div>
  );
};

export default MessageCenter;
